import { createContext, useContext } from "react";
import type { WsReadyState } from "../hooks/useWebSocket";

export interface RouterInfo {
  id: number;
  serial_number: string;
  name: string | null;
  ping_interval: number;
  online: boolean;
  last_seen: string | null;
  created_at: string;
  model_name:    string | null;
  model_version: string | null;
  impulse_id:    number | null;
  ring: string;
  override_batch_id: number | null;
  override_model_version: string | null;
  override_impulse_id: number | null;
  override_by: string | null;
  override_at: string | null;
}

export interface AppContextValue {
  deviceId: string;
  setDeviceId: (id: string) => void;
  lastMessage: unknown;
  wsReadyState: WsReadyState;
  routers: RouterInfo[];
  setRouters: React.Dispatch<React.SetStateAction<RouterInfo[]>>;
  darkMode: boolean;
  toggleDarkMode: () => void;
}

export const AppContext = createContext<AppContextValue>({
  deviceId: "",
  setDeviceId: () => {},
  lastMessage: null,
  wsReadyState: "CLOSED",
  routers: [],
  setRouters: () => {},
  darkMode: false,
  toggleDarkMode: () => {},
});

export const useAppContext = () => useContext(AppContext);
